import React, { useMemo } from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import {
  ButtonShape,
  ButtonVariant,
} from '@vimily/bonjoro-ui-components-v2/Button';

export interface DeleteSocialModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  deleting?: boolean;
}

export const DeleteSocialModal = ({
  open,
  onConfirm,
  onCancel,
  deleting,
}: DeleteSocialModalProps) => {
  const onDeleteClick = () => {
    onConfirm?.();
  };

  const modalProps = useMemo<ModalProps>(() => {
    return {
      open,
      hideCloseButton: true,
      iconUrl: 'https://cdn.bonjoro.com/assets/icons/red-trash-can.svg',
      iconClassName: 'w-11 h-12 !my-0',
      onModalClose: onCancel,
      className: '!w-[480px] !inset-px !p-7',
      panelClassName: 'gap-y-7',
      actionsPanelClassName: '!flex-row-reverse justify-center',
      confirmButtonProps: {
        text: 'Delete',
        variant: ButtonVariant.Danger,
        className: '!v2-bg-orange-600 hover:!v2-bg-orange-700 py-0 h-10',
        shape: ButtonShape.Rectangle,
        onClick: onDeleteClick,
        loading: deleting,
      },
      cancelButtonProps: {
        text: 'Cancel',
        variant: ButtonVariant.Secondary,
        className: 'py-0 h-10',
        shape: ButtonShape.Rectangle,
        onClick: onCancel,
      },
    };
  }, [open]);

  return (
    <Modal {...modalProps}>
      <div className='flex flex-col'>
        <span className='text-xl text-center font-bold'>
          Are you sure you want to delete selected content? Anything published
          with this content will be affected.
        </span>
      </div>
    </Modal>
  );
};
